


// import React, { useState, useEffect } from "react";
// import { Button, Col, Container, Dropdown, Form, Row, Pagination } from "react-bootstrap";
// import ProductCard from "../component/productCard";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchProducts, selectProducts } from "../redux/productSlice";
// import "../css/allProductList.css";
// import "../css/productCategory.css";
// import LoadingSpinner from "../component/loadingSpinner";
// import Navigation from "../component/navigation";
// import ReactSlider from "react-slider";
// import StartRating from "../component/starRating";
// import { FaList, FaRegStar, FaStar, FaTh } from "react-icons/fa";
// import useProductActions from "../utils/productThanos";
// import { initializeReviews, selectReviews } from "../redux/reviewSlice";
// import { selectAverageRating, selectCombinedReviews } from "../utils/reviewSelector";
// import TodaysDeals from "../component/todaysDeals";

// const ProductCategory = () => {
//   const dispatch = useDispatch();
//   const products = useSelector(selectProducts);
//   const reviews = useSelector(selectReviews);
//   const [priceRange, setPriceRange] = useState([0, 1000]);
//   const [sortOrder, setSortOrder] = useState("recentToOld");
//   const [category, setCategory] = useState("All");
//   const [selectedBrands, setSelectedBrands] = useState([]); 
//   const [minRatingFilter, setMinRatingFilter] = useState(0);
//   const [discountFilter, setDiscountFilter] = useState(false);
//   const [viewMode, setViewMode] = useState('grid');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null); 
//   const [filteredBrands, setFilteredBrands] = useState([]);
//   const [itemsPerPage, setItemsPerPage] = useState(5); 
//   const [showTodayDeals, setShowTodayDeals] = useState(false);


//   useEffect(() => {
//     setLoading(true); // Set loading to true when fetching products
//     dispatch(fetchProducts())
//       .then(() => setLoading(false))  // On success, set loading to false
//       .catch((err) => {
//         setLoading(false);
//         setError(err.message);  // Set error state if an error occurs
//       });
//   }, [dispatch]);

//   useEffect(() => {
//     products.forEach((product) => {
//       if (!reviews[product.id]) {
//         dispatch(initializeReviews({ productId: product.id, existingReviews: product.reviewsList }));
//       }
//     });
//   }, [products, reviews, dispatch]);
//   useEffect(() => {
//     setCurrentPage(1);  // Reset to the first page on any filter change
//   }, [priceRange, sortOrder, category, selectedBrands, minRatingFilter, discountFilter,itemsPerPage,showTodayDeals]);
//   useEffect(() => {
//     // Filter brands based on selected category
//     if (category === "All") {
//       setFilteredBrands([...new Set(products.map((product) => product.brand))]);
//     } else {
//       const brandsForCategory = [...new Set(products.filter(product => product.category === category).map((product) => product.brand))];
//       setFilteredBrands(brandsForCategory);
//     }
//   }, [category, products]);


//   // const isDealExpired = (dealEndDate) => {
//   //   const currentDate = new Date();
//   //   const dealEnd = new Date(dealEndDate);
//   //   return dealEnd < currentDate; // Expired if end date is before current date
//   // };


//   const calculateAverageRating = (productId) => {
//     const productReviews = reviews[productId]?.reviewsList || [];
//     if (productReviews.length === 0) return 0;
//     const totalRating = productReviews.reduce((sum, review) => sum + review.PersonRating, 0);
//     return totalRating / productReviews.length;
//   };

//   const filteredProducts = products.filter((product) => {
//     const hasDiscount = discountFilter ? product.discount && product.discount !== "" : true;
//     const isDeal = showTodayDeals ? product.isDeal === true : !product.isDeal;
//     return (
//       product.price >= priceRange[0] &&
//       product.price <= priceRange[1] &&
//       (category === "All" || product.category === category) &&
//       (selectedBrands.length === 0 || selectedBrands.includes(product.brand)) &&
//       calculateAverageRating(product.id) >= minRatingFilter &&
//       hasDiscount && isDeal
//     );
//   });

//   const sortedProducts = filteredProducts.sort((a, b) => {
//     switch (sortOrder) {
//       case "priceLowToHigh":
//         return a.price - b.price;
//       case "priceHighToLow":
//         return b.price - a.price;
//       case "recentToOld":
//         return b.id - a.id;
//       case "oldToRecent":
//         return a.id - b.id;
//       default:
//         return 0;
//     }
//   });

//   const displayedProducts = sortedProducts.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const brands = [...new Set(products.map((product) => product.brand))];

//   const handleBrandChange = (brand) => {
//     setSelectedBrands((prevBrands) =>
//       prevBrands.includes(brand)
//         ? prevBrands.filter((b) => b !== brand)
//         : [...prevBrands, brand]
//     );
//   };

//   const toggleDiscountFilter = () => {
//     setDiscountFilter((prev) => !prev);
//   };

//   const toggleViewMode = () => {
//     setViewMode(prevMode => (prevMode === 'grid' ? 'list' : 'grid'));
//   };

//   const handleRatingFilter = (rating) => {
//     setMinRatingFilter((prev) => (prev === rating ? 0 : rating));
//   };

//   const totalPages = Math.ceil(sortedProducts.length / itemsPerPage);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const generatePaginationItems = () => {
//     const paginationItems = [];
//     // const totalPages = Math.ceil(sortedProducts.length / itemsPerPage);
  
//     // Show first page, last page, current page, previous and next of current, and ellipsis as needed
//     if (totalPages <= 5) {
//       // If total pages are 5 or less, show all page numbers
//       for (let number = 1; number <= totalPages; number++) {
//         paginationItems.push(
//           <Pagination.Item key={number} active={number === currentPage} onClick={() => handlePageChange(number)}>
//             {number}
//           </Pagination.Item>
//         );
//       }
//     } else {
//       // Show more complex pagination if there are more than 5 pages
//       paginationItems.push(
//         <Pagination.Item key={1} active={currentPage === 1} onClick={() => handlePageChange(1)}>
//           1
//         </Pagination.Item>
//       );
  
//       if (currentPage > 3) {
//         paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
//       }
  
//       const startPage = Math.max(2, currentPage - 1);
//       const endPage = Math.min(totalPages - 1, currentPage + 1);
  
//       for (let number = startPage; number <= endPage; number++) {
//         paginationItems.push(
//           <Pagination.Item key={number} active={number === currentPage} onClick={() => handlePageChange(number)}>
//             {number}
//           </Pagination.Item>
//         );
//       }
  
//       if (currentPage < totalPages - 2) {
//         paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
//       }
  
//       paginationItems.push(
//         <Pagination.Item key={totalPages} active={currentPage === totalPages} onClick={() => handlePageChange(totalPages)}>
//           {totalPages}
//         </Pagination.Item>
//       );
//     }
  
//     return paginationItems;
//   };
//   const handleShowTodayDeals = () => {
//     setShowTodayDeals((prev) => !prev); // Toggle TodayDeals view
//   };


//   return (
//     <>
//       <Navigation />
//       <section className="mt-4 filterWrapper">
//         <div className="leftSidebarMenuFilter">
//           <div className="productAllFilterOption">
//             <div className="price-filter mb-4">
//               <h5>Filter by Price</h5>
//               <ReactSlider
//                 className="horizontal-slider"
//                 thumbClassName="slider-thumb"
//                 trackClassName="slider-track"
//                 min={0}
//                 max={1000}
//                 value={priceRange}
//                 onChange={(range) => setPriceRange(range)}
//                 renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
//               />
//               <p>Price: ${priceRange[0]} - ${priceRange[1]}</p>
//             </div>
//             <div className="todaydealsFilterOptions">
//             <label>
//         <input
//           type="checkbox"
//           checked={showTodayDeals}
//           onChange={handleShowTodayDeals}
//         />
//         {showTodayDeals ? "Hide Today's Deals" : "Show Today's Deals"}
//       </label>
//               {/* Other top bar options here */}
//             </div>
//             <div className="category-filter mb-4">
//               <h5>Filter by Category</h5>
//               <Dropdown>
//                 <Dropdown.Toggle variant="primary" id="category-dropdown">
//                   {category === "All" ? "All Categories" : category}
//                 </Dropdown.Toggle>
//                 <Dropdown.Menu>
//                   <Dropdown.Item onClick={() => setCategory("All")}>All Categories</Dropdown.Item>
//                   <Dropdown.Item onClick={() => setCategory("Headphone")}>Headphone</Dropdown.Item>
//                   <Dropdown.Item onClick={() => setCategory("Electronics")}>Electronics</Dropdown.Item>
//                   <Dropdown.Item onClick={() => setCategory("Light")}>Light</Dropdown.Item>
//                 </Dropdown.Menu>
//               </Dropdown>
//             </div>
//             <div className="brand-filter mb-4">
//               <h5>Filter by Brand</h5>
//               {filteredBrands.map((brand) => (
//                 <Form.Check
//                   key={brand}
//                   type="checkbox"
//                   label={brand}
//                   checked={selectedBrands.includes(brand)}
//                   onChange={() => handleBrandChange(brand)}
//                 />
//               ))}
//             </div>
//             <div className="rating-filter mb-4">
//               <h5>Filter by Rating</h5>
//               <div style={{ cursor: "pointer" }}>
//                 {[...Array(5)].map((_, i) => (
//                   <span key={i} onClick={() => handleRatingFilter(i + 1)}>
//                     {i < minRatingFilter ? <FaStar style={{ color: 'var(--ratingStar)' }} /> : <FaRegStar style={{ color: 'var(--ratingColorNone)' }} />}
//                   </span>
//                 ))}
//               </div>
//               <p>Showing products with {minRatingFilter} star and up</p>
//             </div>
//             <div className="discount-filter mb-4">
//               <Form.Check
//                 type="checkbox"
//                 label="Discounted Products Only"
//                 checked={discountFilter}
//                 onChange={toggleDiscountFilter}
//               />
//             </div>
//           </div>
//         </div>
//         <div className="rightBarProductShowFilter">
//           <Container fluid>
//             <div className="topbarFilterOptions d-flex align-items-center">
//               <Button onClick={toggleViewMode} variant="outline-secondary">
//                 {viewMode === 'grid' ? <FaList /> : <FaTh />} {viewMode === 'grid' ? 'List View' : 'Grid View'}
//               </Button>
//               <Dropdown>
//                 <Dropdown.Toggle variant="primary" id="dropdown-basic">
//                   {sortOrder === "priceLowToHigh"
//                     ? "Price Low to High"
//                     : sortOrder === "priceHighToLow"
//                     ? "Price High to Low"
//                     : sortOrder === "recentToOld"
//                     ? "Recent to Old"
//                     : "Old to Recent"}
//                 </Dropdown.Toggle>
//                 <Dropdown.Menu>
//                   <Dropdown.Item onClick={() => setSortOrder("priceLowToHigh")}>Price Low to High</Dropdown.Item>
//                   <Dropdown.Item onClick={() => setSortOrder("priceHighToLow")}>Price High to Low</Dropdown.Item>
//                   <Dropdown.Item onClick={() => setSortOrder("recentToOld")}>Recent to Old</Dropdown.Item>
//                   <Dropdown.Item onClick={() => setSortOrder("oldToRecent")}>Old to Recent</Dropdown.Item>
//                 </Dropdown.Menu>
//               </Dropdown>
//               <Dropdown>
//                 <Dropdown.Toggle variant="secondary" id="dropdown-items-per-page">
//                   {itemsPerPage} items per page
//                 </Dropdown.Toggle>
//                 <Dropdown.Menu>
//                   <Dropdown.Item onClick={() => setItemsPerPage(5)}>5 items per page</Dropdown.Item>
//                   <Dropdown.Item onClick={() => setItemsPerPage(10)}>10 items per page</Dropdown.Item>
//                   <Dropdown.Item onClick={() => setItemsPerPage(15)}>15 items per page</Dropdown.Item>
//                   <Dropdown.Item onClick={() => setItemsPerPage(20)}>20 items per page</Dropdown.Item>
//                 </Dropdown.Menu>
//               </Dropdown>
//             </div>
//             <Row>
//             {showTodayDeals ? (
//               <TodaysDeals />
//             ) : displayedProducts.length > 0 ? (
//               displayedProducts.map((product) => (
//                 <ProductCard
//                   key={product.id}
//                   axlio={3}
//                   product={product}
//                   viewMode={viewMode}
//                   axliox={viewMode === "grid" ? 4 : 12}
//                 />
//               ))
//             ) : (
//               <Col className="text-center">
//                 <p className="text-muted" style={{ fontSize: "1.5rem", marginTop: "2rem" }}>
//                   Filtering product not found
//                 </p>
//               </Col>
//             )}
//           </Row>
//             {displayedProducts.length >0 && (

//             <Pagination className="justify-content-center mt-4">
//             <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//             <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//             {generatePaginationItems()}
//             <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//             <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//           </Pagination>
//           )}
//           </Container>
//         </div>
//       </section>
//     </>
//   );
// };

// export default ProductCategory;



import React, { useState, useEffect } from "react";
import { Button, Col, Container, Dropdown, Form, Row, Pagination } from "react-bootstrap";
import ProductCard from "../component/productCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts, selectProducts } from "../redux/productSlice";
import "../css/allProductList.css";
import "../css/productCategory.css";
import LoadingSpinner from "../component/loadingSpinner";
import Navigation from "../component/navigation";
import ReactSlider from "react-slider";
import StartRating from "../component/starRating";
import { FaList, FaRegStar, FaStar, FaTh } from "react-icons/fa";
import useProductActions from "../utils/productThanos";
import { initializeReviews, selectReviews } from "../redux/reviewSlice";
import { selectAverageRating, selectCombinedReviews } from "../utils/reviewSelector";
import TodaysDeals from "../component/todaysDeals";

const ProductCategory = () => {
  const dispatch = useDispatch();
  const products = useSelector(selectProducts);
  const reviews = useSelector(selectReviews);
  const [priceRange, setPriceRange] = useState([0, 1000]);
  const [sortOrder, setSortOrder] = useState("recentToOld");
  const [category, setCategory] = useState("All");
  const [selectedBrands, setSelectedBrands] = useState([]); 
  const [minRatingFilter, setMinRatingFilter] = useState(0);
  const [discountFilter, setDiscountFilter] = useState(false);
  const [viewMode, setViewMode] = useState('grid');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); 
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(5); 
  const [showTodayDeals, setShowTodayDeals] = useState(false);


  useEffect(() => {
    setLoading(true); // Set loading to true when fetching products
    dispatch(fetchProducts())
      .then(() => setLoading(false))  // On success, set loading to false
      .catch((err) => {
        setLoading(false);
        setError(err.message);  // Set error state if an error occurs
      });
  }, [dispatch]);

  useEffect(() => {
    products.forEach((product) => {
      if (!reviews[product.id]) {
        dispatch(initializeReviews({ productId: product.id, existingReviews: product.reviewsList }));
      }
    });
  }, [products, reviews, dispatch]);
  useEffect(() => {
    setCurrentPage(1);  // Reset to the first page on any filter change
  }, [priceRange, sortOrder, category, selectedBrands, minRatingFilter, discountFilter,itemsPerPage,showTodayDeals]);
  useEffect(() => {
    // Filter brands based on selected category
    if (category === "All") {
      setFilteredBrands([...new Set(products.map((product) => product.brand))]);
    } else {
      const brandsForCategory = [...new Set(products.filter(product => product.category === category).map((product) => product.brand))];
      setFilteredBrands(brandsForCategory);
    }
  }, [category, products]);


  // const isDealExpired = (dealEndDate) => {
  //   const currentDate = new Date();
  //   const dealEnd = new Date(dealEndDate);
  //   return dealEnd < currentDate; // Expired if end date is before current date
  // };


  const calculateAverageRating = (productId) => {
    const productReviews = reviews[productId]?.reviewsList || [];
    if (productReviews.length === 0) return 0;
    const totalRating = productReviews.reduce((sum, review) => sum + review.PersonRating, 0);
    return totalRating / productReviews.length;
  };

  const filteredProducts = products.filter((product) => {
    const hasDiscount = discountFilter ? product.discount && product.discount !== "" : true;
    const isDeal = showTodayDeals ? product.isDeal === true : !product.isDeal;
    return (
      product.price >= priceRange[0] &&
      product.price <= priceRange[1] &&
      (category === "All" || product.category === category) &&
      (selectedBrands.length === 0 || selectedBrands.includes(product.brand)) &&
      calculateAverageRating(product.id) >= minRatingFilter &&
      hasDiscount && isDeal
    );
  });

  const sortedProducts = filteredProducts.sort((a, b) => {
    switch (sortOrder) {
      case "priceLowToHigh":
        return a.price - b.price;
      case "priceHighToLow":
        return b.price - a.price;
      case "recentToOld":
        return b.id - a.id;
      case "oldToRecent":
        return a.id - b.id;
      default:
        return 0;
    }
  });

  const displayedProducts = sortedProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const brands = [...new Set(products.map((product) => product.brand))];

  const handleBrandChange = (brand) => {
    setSelectedBrands((prevBrands) =>
      prevBrands.includes(brand)
        ? prevBrands.filter((b) => b !== brand)
        : [...prevBrands, brand]
    );
  };

  const toggleDiscountFilter = () => {
    setDiscountFilter((prev) => !prev);
  };

  const toggleViewMode = () => {
    setViewMode(prevMode => (prevMode === 'grid' ? 'list' : 'grid'));
  };

  const handleRatingFilter = (rating) => {
    setMinRatingFilter((prev) => (prev === rating ? 0 : rating));
  };

  const totalPages = Math.ceil(sortedProducts.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const generatePaginationItems = () => {
    const paginationItems = [];
    // const totalPages = Math.ceil(sortedProducts.length / itemsPerPage);
  
    // Show first page, last page, current page, previous and next of current, and ellipsis as needed
    if (totalPages <= 5) {
      // If total pages are 5 or less, show all page numbers
      for (let number = 1; number <= totalPages; number++) {
        paginationItems.push(
          <Pagination.Item key={number} active={number === currentPage} onClick={() => handlePageChange(number)}>
            {number}
          </Pagination.Item>
        );
      }
    } else {
      // Show more complex pagination if there are more than 5 pages
      paginationItems.push(
        <Pagination.Item key={1} active={currentPage === 1} onClick={() => handlePageChange(1)}>
          1
        </Pagination.Item>
      );
  
      if (currentPage > 3) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
      }
  
      const startPage = Math.max(2, currentPage - 1);
      const endPage = Math.min(totalPages - 1, currentPage + 1);
  
      for (let number = startPage; number <= endPage; number++) {
        paginationItems.push(
          <Pagination.Item key={number} active={number === currentPage} onClick={() => handlePageChange(number)}>
            {number}
          </Pagination.Item>
        );
      }
  
      if (currentPage < totalPages - 2) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      }
  
      paginationItems.push(
        <Pagination.Item key={totalPages} active={currentPage === totalPages} onClick={() => handlePageChange(totalPages)}>
          {totalPages}
        </Pagination.Item>
      );
    }
  
    return paginationItems;
  };
  const handleShowTodayDeals = () => {
    setShowTodayDeals((prev) => !prev); // Toggle TodayDeals view
  };


  return (
    <>
      <Navigation />
      <section className="mt-4 filterWrapper">
        <div className="leftSidebarMenuFilter">
          <div className="productAllFilterOption">
            <div className="price-filter mb-4">
              <h5>Filter by Price</h5>
              <ReactSlider
                className="horizontal-slider"
                thumbClassName="slider-thumb"
                trackClassName="slider-track"
                min={0}
                max={1000}
                value={priceRange}
                onChange={(range) => setPriceRange(range)}
                // renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
              />
              <p>Price: ${priceRange[0]} - ${priceRange[1]}</p>
            </div>
            <div className="">
            <label>
              <input
                type="checkbox"
                
              />
            Onsell
            </label>
            </div>
            <div className="">
            <label>
              <input
                type="checkbox"
                
              />
            Top sell
            </label>
            </div>
            <div className="todaydealsFilterOptions">
            <label>
        <input
          type="checkbox"
          checked={showTodayDeals}
          onChange={handleShowTodayDeals}
        />
        {showTodayDeals ? "Hide Today's Deals" : "Show Today's Deals"}
      </label>
              {/* Other top bar options here */}
            </div>
            <div className="discount-filter mb-4">
              <Form.Check
                type="checkbox"
                label="Discounted Products Only"
                checked={discountFilter}
                onChange={toggleDiscountFilter}
              />
            </div>
            <div className="category-filter mb-4">
              <h5>Filter by Category</h5>
              <Dropdown>
                <Dropdown.Toggle variant="primary" id="category-dropdown">
                  {category === "All" ? "All Categories" : category}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setCategory("All")}>All Categories</Dropdown.Item>
                  <Dropdown.Item onClick={() => setCategory("Headphone")}>Headphone</Dropdown.Item>
                  <Dropdown.Item onClick={() => setCategory("Electronics")}>Electronics</Dropdown.Item>
                  <Dropdown.Item onClick={() => setCategory("Light")}>Light</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="brand-filter mb-4">
              <h5>Filter by Brand</h5>
              {filteredBrands.map((brand) => (
                <Form.Check
                  key={brand}
                  type="checkbox"
                  label={brand}
                  checked={selectedBrands.includes(brand)}
                  onChange={() => handleBrandChange(brand)}
                />
              ))}
            </div>
            <div className="rating-filter mb-4">
              <h5>Filter by Rating</h5>
              <div className="d-flex">
                 <div style={{ cursor: "pointer" }}>
                {[...Array(5)].map((_, i) => (
                  <span key={i} onClick={() => handleRatingFilter(i + 1)}>
                    {i < minRatingFilter ? <FaStar style={{ color: 'var(--ratingStar)' }} /> : <FaRegStar style={{ color: 'var(--ratingColorNone)' }} />}
                  </span>
                ))}
              </div>
              {/* <p>Showing products with {minRatingFilter} star and up</p> */}
              <p>&nbsp; & up</p>
              </div>
             
            </div>
            
          </div>
        </div>
        <div className="rightBarProductShowFilter">
          <Container fluid>
            <div className="topbarFilterOptions d-flex align-items-center">
              <Button onClick={toggleViewMode} variant="outline-secondary">
                {viewMode === 'grid' ? <FaList /> : <FaTh />} {viewMode === 'grid' ? 'List View' : 'Grid View'}
              </Button>
        
              <Dropdown>
                <Dropdown.Toggle variant="primary" id="dropdown-basic">
                  {sortOrder === "priceLowToHigh"
                    ? "Price Low to High"
                    : sortOrder === "priceHighToLow"
                    ? "Price High to Low"
                    : sortOrder === "recentToOld"
                    ? "Recent to Old"
                    : "Old to Recent"}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setSortOrder("priceLowToHigh")}>Price Low to High</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSortOrder("priceHighToLow")}>Price High to Low</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSortOrder("recentToOld")}>Recent to Old</Dropdown.Item>
                  <Dropdown.Item onClick={() => setSortOrder("oldToRecent")}>Old to Recent</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown>
                <Dropdown.Toggle variant="secondary" id="dropdown-items-per-page">
                  {itemsPerPage} items per page
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setItemsPerPage(5)}>5 items per page</Dropdown.Item>
                  <Dropdown.Item onClick={() => setItemsPerPage(10)}>10 items per page</Dropdown.Item>
                  <Dropdown.Item onClick={() => setItemsPerPage(15)}>15 items per page</Dropdown.Item>
                  <Dropdown.Item onClick={() => setItemsPerPage(20)}>20 items per page</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <Row>
            {showTodayDeals ? (
              <TodaysDeals />
            ) : displayedProducts.length > 0 ? (
              displayedProducts.map((product) => (
                <ProductCard
                  key={product.id}
                  axlio={3}
                  product={product}
                  viewMode={viewMode}
                  axliox={viewMode === "grid" ? 4 : 12}
                />
              ))
            ) : (
              <Col className="text-center">
                <p className="text-muted" style={{ fontSize: "1.5rem", marginTop: "2rem" }}>
                  Filtering product not found
                </p>
              </Col>
            )}
          </Row>
            {displayedProducts.length >0 && (

            <Pagination className="justify-content-center mt-4">
            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
            {generatePaginationItems()}
            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
            <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
          </Pagination>
          )}
          </Container>
        </div>
      </section>
    </>
  );
};

export default ProductCategory;
